module.exports = __webpack_public_path__ + "img/95_6.6404c47c.png";